import { useEffect, useState } from 'react';
import { getLanguageStorage, setLanguageStorage } from 'utils/localStorage';
import Select, { SelectProps } from '../../../styles/select/Select';
import { SelectChangeEvent } from '@mui/material';
import { ReactComponent as ArrowDownIcon } from 'assett/icons/arrow_down_icon.svg';
import { getFooterLinks } from 'feature/footer/footerSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import styled from 'styled-components';
import { SelectItemText } from 'styles';
import FormControl from 'styles/form/FormControl';
import MenuItem from 'styles/menu/MenuItem';
import Radio from 'styles/radio/Radio';
import Stack from 'styles/stack/Stack';
import { LANGUAGES } from 'types/Localization';
import i18n from 'i18next';

type Props = SelectProps;
const StyledSelect = styled(Select)<Props>``;

const SelectLanguage: React.FC<Props> = props => {
	const [value, setValue] = useState<string>(getLanguageStorage() as string);
	const dispatch = useDispatch<AppDispatch>();

	const handleChange = (e: SelectChangeEvent<any>) => {
		const { value } = e.target;
		setValue(value);
		i18n.changeLanguage(e.target.value.substring(0, 2));
		setLanguageStorage(value);
	};

	useEffect(() => {
		if (value) {
			dispatch(getFooterLinks(''));
		}
	}, [dispatch, value]);

	return (
		<Stack mt={{ lg: '41px', sm: '30px' }}>
			<FormControl>
				<StyledSelect
					{...props}
					size="small"
					sx={{ ...props.sx, width: 180, background: 'white' }}
					value={value.toLowerCase()}
					renderValue={() =>
						LANGUAGES.find(e => e.id === value.toLowerCase())?.label
					}
					onChange={handleChange}
					IconComponent={ArrowDownIcon}
				>
					{LANGUAGES.map(e => (
						<MenuItem key={e.id} value={e.id} disableTouchRipple>
							<Radio checked={value.toLowerCase() === e.id} />
							<SelectItemText primary={e.label} />
						</MenuItem>
					))}
				</StyledSelect>
			</FormControl>
		</Stack>
	);
};

export default SelectLanguage;
